import { render, staticRenderFns } from "./AIInfoCard.vue?vue&type=template&id=21eddf94&scoped=true"
import script from "./AIInfoCard.vue?vue&type=script&lang=js"
export * from "./AIInfoCard.vue?vue&type=script&lang=js"
import style0 from "./AIInfoCard.vue?vue&type=style&index=0&id=21eddf94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eddf94",
  null
  
)

export default component.exports